"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("../image"));
var mapTiles = function mapTiles(tilesSlice) {
  if (!tilesSlice || tilesSlice.length === 0) return false;
  var tiles = [];
  tilesSlice.map(function (tileSlice) {
    tileSlice.items.map(function (tile) {
      var _tile$title$, _tile$link, _tile$link2, _tile$blurhash, _tile$label;
      tiles.push({
        title: (_tile$title$ = tile.title[0]) === null || _tile$title$ === void 0 ? void 0 : _tile$title$.text,
        url: tile.is_url_external ? (_tile$link = tile.link) === null || _tile$link === void 0 ? void 0 : _tile$link.url : (_tile$link2 = tile.link) !== null && _tile$link2 !== void 0 && _tile$link2.url ? tile.link.url.replace("https:/", "") : "/",
        image: (0, _image["default"])(tile.image, ((_tile$blurhash = tile.blurhash) === null || _tile$blurhash === void 0 ? void 0 : _tile$blurhash.length) > 0 && tile.blurhash[0].text),
        promoLabel: {
          labelText: ((_tile$label = tile.label) === null || _tile$label === void 0 ? void 0 : _tile$label.length) > 0 && tile.label[0].text,
          labelColor: tile.color ? tile.color : "active"
        }
      });
    });
  });
  return tiles;
};
var _default = mapTiles;
exports["default"] = _default;